import React from 'react'

export default ({ color = '#120A20', width = '24', height = '24' }) => (
    <svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
        <path d="M12 2c5.523 0 10 1.567 10 3.5v.727a2 2 0 01-.52 1.345L14 15.8V21c0 .522-.799.95-1.818.996L12 22c-1.105 0-2-.448-2-1v-5.201L2.52 7.572A2 2 0 012 6.227V5.5l.005-.113C2.176 3.507 6.585 2 12 2zm0 2c-4.142 0-7.5.672-7.5 1.5S7.858 7 12 7c4.142 0 7.5-.672 7.5-1.5S16.142 4 12 4z" fill={color} fillRule="evenodd"/>
    </svg>
)
